import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_MS);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, SHOW_MS + GAP_MS);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 flex md:bottom-6 md:left-6 md:right-auto" aria-live="polite" data-id="element-42" data-mp="117o5i0ns7b5p">
      <AnimatePresence data-id="element-43" data-mp="1fv0s7spbrmxo">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-navy/10" data-id="element-44" data-mp="1awfsdudzj59r">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-cream object-contain" data-id="element-45" data-mp="28kg74tk41zyv" />
            <div className="min-w-0" data-id="element-46" data-mp="23lmxxdbuwv4i">
              <p className="text-sm leading-snug text-ink" data-id="element-47" data-mp="23klfuowfb8da">
                <strong data-id="element-48" data-mp="2ap2zp6tk2k9l">{buyer.name}</strong> from <strong data-id="element-49" data-mp="2anrwp97xpgjj">{buyer.country}</strong> just purchased the Blepharoplasty Decision Lab™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-cta" data-id="element-50" data-mp="2flte7pppp7sw">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2knaepk4aas8y" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 ease-out hover:bg-cream hover:text-ink" aria-label="Dismiss notification" data-id="element-52" data-mp="1ryv1920swhzq">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="26o19tglj3kka" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}